<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised has-margin-top-30">
            <div class="card-body">
              <div class="has-text-centered">
                <h2 class="title">Order your team shirts</h2>
                <img
                  src="https://res.cloudinary.com/nailedd/image/upload/v1689521378/capturefit/steel-monkey-kustomz/steel-monkey-kustomz.png"
                  alt="Steel Monkey Kustomz"
                />
                <h4 class="subtitle">
                  CaptureFit has partnered with Steel Monkey Kustomz to order
                  your team shirts straight from our platform. <br />(Note: Only
                  available to South African Events)
                </h4>
              </div>

              <hr />
              <p>
                <strong
                  >If you order through CaptureFit you get it at a special rate
                  of R290 per shirt. Free shipping for orders over R899.</strong
                >
              </p>

              <p>
                <strong
                  >Steel Monkey Kustomz also provide custom design services,
                  please email them below if you require any.</strong
                >
              </p>
              <p>
                Please email
                <a href="mailto:steelmonkeysa@gmail.com"
                  >steelmonkeysa@gmail.com</a
                >
                for any other queries regards the shirts.
              </p>
              <br />
              <div class="has-text-centered has-margin-top-15">
                <button
                  class="button is-primary is-large"
                  @click="ordernow = true"
                  v-if="!ordernow"
                >
                  Order Now
                </button>
              </div>
              <div v-if="ordernow">
                <hr />
                <h3 class="is-size-4 has-text-weight-bold has-margin-top-30">
                  Your Order
                </h3>
              </div>
              <div class="has-padding-15" v-if="ordernow">
                <ValidationObserver
                  v-slot="{ passes }"
                  ref="contactDetailsObserver"
                >
                  <form name="form">
                    <div class="columns is-multiline">
                      <div class="column is-desktop-6">
                        <h4 class="has-text-weight-bold has-margin-bottom-15">
                          Contact Details:
                        </h4>
                        <div class="control">
                          <BaseInput
                            type="email"
                            label="Email Address"
                            rules="required"
                            v-model="order.email"
                          />
                        </div>
                        <div class="control">
                          <BaseInput
                            label="Mobile Number"
                            rules="required"
                            v-model="order.mobile"
                          />
                        </div>
                        <div class="control">
                          <BaseInput
                            label="Other Special Instructions"
                            type="textarea"
                            v-model="order.instructions"
                          />
                        </div>
                      </div>
                      <div class="column is-desktop-6">
                        <h4 class="has-text-weight-bold has-margin-bottom-15">
                          Delivery Address:
                        </h4>
                        <div class="control">
                          <BaseInput
                            label="Address Line 1"
                            v-model="order.addressline1"
                            rules="required"
                          />
                        </div>
                        <div class="control">
                          <BaseInput
                            label="Address Line 2"
                            v-model="order.addressline2"
                          />
                        </div>
                        <div class="control">
                          <BaseInput label="Suburb" v-model="order.suburb" />
                        </div>
                        <div class="control">
                          <BaseInput
                            label="City"
                            v-model="order.city"
                            rules="required"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered has-margin-top-30">
                      <p>
                        <strong
                          >Steel Monkey Kustomz will be in contact with you once
                          they've received your order.</strong
                        >
                      </p>
                      <b-button
                        class="button is-primary is-medium has-margin-top-15"
                        :loading="saving"
                        @click="passes(submit)"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseInput from "@/components/BaseInput";
import BaseSelect from "@/components/BaseSelect";
import OrderApi from "@/api/tshirt-order";

export default {
  name: "OrderShirts",
  data() {
    return {
      loading: true,
      adding: true,
      saving: false,
      ordernow: false,
      order: {
        location: "Delivery: Cape Town (R80)",
      },
      orderlines: [],
      line: {
        athlete: null,
        option: null,
      },
      logocolours: [
        "Nightclub",
        "GITD",
        "White 01",
        "Lemon Yellow 05",
        "Sunny Yellow 06",
        "Orange 07",
        "Fire Red 11",
        "Passion Red 33",
        "Electric Red 12",
        "Red 10",
        "Baby Pink 08",
        "Fuchsia 09",
        "Burgundy 13",
        "Lavender 37",
        "Plum 38",
        "Purple 23",
        "Sky Blue 17",
        "Atoll Blue 18",
        "Pacific Blue 19",
        "Reflex Blue 20",
        "Royal Blue 21",
        "Navy Blue 22",
        "Turquoise 34",
        "Vibrant Green 35",
        "Apple Green 24",
        "Light Green 36",
        "Green 25",
        "Military Green 26",
        "Beige 03",
        "Chocolate 04",
        "Cool Grey 14",
        "Grey 15",
        "Dark Grey 16",
        "Black 02",
        "Silver Metallic 31",
        "Gold Metallic 32",
        "Neon Yellow 39",
        "Neon Orange 40",
        "Neon Pink 41",
        "Neon Green 42",
      ],
      sizes: [],
      colours: [],
    };
  },
  components: {
    BaseInput,
    BaseSelect,
  },
  computed: {
    ...mapGetters(["user"]),
    orderTotal() {
      let total = 0;
      this.orderlines.forEach((line) => {
        total += (line.noofcolours == 1 ? 330 : 350) * line.qty;
      });
      total += this.order.location === "Delivery: Cape Town (R80)" ? 80 : 150;
      return total;
    },
  },
  async created() {
    this.loading = false;
  },
  methods: {
    editLine(line) {
      this.line = line;
      this.adding = false;
    },
    deleteLine(line) {
      this.orderlines = this.orderlines.filter(
        (item) => item.athlete !== line.athlete
      );
    },
    changeType(type) {
      switch (type) {
        case "Tanks - Ladies":
          this.sizes = ["XS", "S", "M", "L", "XL", "2XL"];
          this.colours = ["Red", "Petrol Blue", "Charcoal"];
          break;
        case "Crop Top - Ladies":
          this.sizes = ["XS", "S", "M", "L", "XL", "2XL"];
          this.colours = ["Red", "Petrol Blue", "Charcoal"];
          break;
        case "T-Shirts - Unisex":
          this.sizes = ["XS", "S", "M", "L", "XL", "2XL"];
          this.colours = ["Red", "Petrol Blue", "Charcoal"];
          break;
      }
    },
    updateLine() {
      if (this.adding) {
        this.orderlines.push(JSON.parse(JSON.stringify(this.line)));
      }
      this.line = {
        athlete: null,
        option: null,
      };
      this.adding = true;
      this.$refs.lineObserver.reset();
    },
    async submit() {
      this.saving = true;
      this.order.orderlines = this.orderlines;
      try {
        await OrderApi.saveOrder(this.order);
        this.saving = false;
        this.ordernow = false;
        this.$buefy.toast.open({
          message: "Your order has been submitted successfully!",
          position: "is-top",
          type: "is-success",
        });
      } catch (error) {
        console.log(error);
        this.saving = false;
        this.$buefy.toast.open({
          message: "Error submitting order!",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>
